<template>
  <bottom-bar-layout v-if="loaded"
                     class="page-reading-day"
                     show-bar
                     :bar-height="150"
                     :shadow="false"
  >
    <ym-img class="page-reading-day-header"
            :src="require('@/pages/2021/ReadingDay/assets/img/header_bg.png')"
    />
    <count-down v-if="render.status === 'started' && render.lastDay < 4"
                :render="render"
                @count-down-ended="handleCountDownEnded"
    />
<!--    <purchase :purchase="purchase" />-->
    <card v-if="live.show"
          type-name="live"
          v-ym-report:MARKETING_2021READINGDAY_LIVE_EXPOSURE=""
    >
      <div class="page-reading-day-live">
        <ym-img class="page-reading-day-live-cover"
                :src="live.cover"
        />
        <ym-img class="page-reading-day-live-btn"
                :src="require('@/pages/2021/ReadingDay/assets/img/live_btn.png')"
                @click="showLiveSubscribe = true"
                v-ym-report:MARKETING_2021READINGDAY_LIVE_ORDER_CLICK=""
        />
      </div>
    </card>
    <card type-name="group">
      <div class="page-reading-day-group">
        <div class="page-reading-day-group-list">
          <group-item v-for="(item,index) in group.list"
                      :key="index"
                      :item="item"
                      go-list
          />
        </div>
        <router-link v-if="group.showMore"
                     :to="{ name: 'ReadingDayGroup' }"
                     v-ym-report:MARKETING_2021READINGDAY_GROUPON_MORE_CLICK=""
        >
          <ym-img class="page-reading-day-group-btn"
                  :src="require('@/pages/2021/ReadingDay/assets/img/group_btn.png')"
          />
        </router-link>
      </div>
    </card>
    <card type-name="million"
          v-ym-report:MARKETING_2021READINGDAY_MILLIONREAD_EXPOSURE=""
    >
      <div class="page-reading-day-million">
        <div class="page-reading-day-million-content"
             v-html="million.content"></div>
        <router-link :to="million.path"
                     class="page-reading-day-card-btn"
                     v-ym-report:MARKETING_2021READINGDAY_MILLIONREAD_BUY_CLICK=""
        >
          立即开通
        </router-link>
      </div>
    </card>
    <card type-name="audio">
      <div class="page-reading-day-audio">
        <div class="page-reading-day-audio-list">
          <audio-item v-for="(item,index) in audio.list"
                      :key="index"
                      :item="item"
                      go-list
          />
        </div>
        <router-link v-if="audio.showMore"
                     :to="{ name: 'ReadingDayAudio' }"
                     class="page-reading-day-card-btn"
                     v-ym-report:MARKETING_2021READINGDAY_RADIO_MORE_CLICK=""
        >
          开启耳朵阅读之旅
        </router-link>
      </div>
    </card>
    <card type-name="project">
      <div class="page-reading-day-project">
        <div class="page-reading-day-project-list">
          <project-item v-for="(item,index) in project.list"
                        :key="index"
                        :item="item"
          />
        </div>
        <div class="page-reading-day-project-more">
          {{ project.moreTitle }}
        </div>
        <router-link v-if="project.showMore"
                     :to="{ name: 'ReadingDayProject' }"
                     class="page-reading-day-card-btn"
                     v-ym-report:MARKETING_2021READINGDAY_PROJECT_MORE_CLICK=""
        >
          点击了解
        </router-link>
      </div>
    </card>
    <div class="page-reading-day-public-welfare"
         v-ym-report:MARKETING_2021READINGDAY_CHARITY_EXPOSURE=""
    >
      <router-link :to="{ name: 'PublicWelfare' }"
                   class="page-reading-day-card-btn"
                   v-ym-report:MARKETING_2021READINGDAY_CHARITY_JOIN_CLICK=""
      >
        我要参加
      </router-link>
    </div>
    <card type-name="rule">
      <div class="page-reading-day-rule">
        <div v-for="(item, index) in rule"
             :key="index"
             class="page-reading-day-rule-item">
          <span>{{ index + 1 }}.</span>
          {{ item }}
        </div>
      </div>
    </card>
    <contact-us-bar slot="tabbar"
                    url=""
                    bottom-color="#e84734"
                    top-color="#f57749"
                    text-color="#ffffff"
                    @wechat="showWechatContact = true"
    />
    <qr-code-popup :show.sync="showLiveSubscribe"
                   :title="'扫码添加老师，<br>回复“直播”即可预约'"
                   :qrcode="live.qrcode"
    />
    <qr-code-popup :show.sync="showWechatContact"
                   :title="'如有疑问欢迎扫码<br>添加老师进行咨询'"
                   :qrcode="require('@/pages/2021/ReadingDay/assets/img/wechat_contact.jpg')"
    />
    <ended-popup :show="showEndedPopup" />
  </bottom-bar-layout>
</template>

<script>
  import { getReadingDayInfo } from '@/services/reading-day-2021';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import ContactUsBar from '@/pages/2021/ReadingDay/components/ContactUsBar';
  import CountDown from '@/pages/2021/ReadingDay/components/CountDown';
  // import Purchase from '@/pages/2021/ReadingDay/components/Purchase';
  import Card from '@/pages/2021/ReadingDay/components/Card';
  import GroupItem from '@/pages/2021/ReadingDay/components/GroupItem';
  import AudioItem from '@/pages/2021/ReadingDay/components/AudioItem';
  import ProjectItem from '@/pages/2021/ReadingDay/components/ProjectItem';
  import QrCodePopup from '@/pages/2021/ReadingDay/components/QrCodePopup';
  import EndedPopup from '@/pages/2021/ReadingDay/components/EndedPopup';

  export default {
    name: 'ReadingDay',
    components: {
      BottomBarLayout,
      ContactUsBar,
      CountDown,
      // Purchase,
      Card,
      GroupItem,
      AudioItem,
      ProjectItem,
      QrCodePopup,
      EndedPopup,
    },
    data() {
      return {
        loaded: false,
        render: {},
        purchase: {},
        live: {},
        audio: {},
        million: {},
        rule: [],
        /* eslint-disable global-require */
        group: {
          list: [
            {
              id: 22,
              cover: require('@/pages/2021/ReadingDay/assets/img/group_22.png'),
            },
            {
              id: 26,
              cover: require('@/pages/2021/ReadingDay/assets/img/group_26.png'),
            },
          ],
          showMore: true,
        },
        project: {
          list: [
            {
              id: 158,
              cover: require('@/pages/2021/ReadingDay/assets/img/project_158.png'),
            },
            {
              id: 163,
              cover: require('@/pages/2021/ReadingDay/assets/img/project_163.png'),
            },
          ],
          moreTitle: '更有帆船等多个主题线下项目限时特惠',
          showMore: true,
        },
        showLiveSubscribe: false,
        showWechatContact: false,
        showEndedPopup: false,
      };
    },
    methods: {
      async fetchData() {
        const data = await getReadingDayInfo();
        const { render } = data;
        if (render.countDown) {
          render.countDown.startTime = Math.round(new Date().getTime() / 1000);
        }
        if (render.status === 'ended') {
          setTimeout(() => {
            this.showEndedPopup = true;
          }, 0);
        }
        this.render = render;
        this.purchase = data.purchase;
        this.live = data.live;
        this.million = data.million;
        this.audio = data.audio;
        this.rule = data.rule;
        this.loaded = true;
      },
      handleCountDownEnded() {
        this.render.status = 'ended';
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-reading-day {
    min-height: 100%;
    background: #5581f5;
    &-header {
      width: 100%;
      height: 1156px;
    }
    &-live {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 100px 0 10px;
      &-cover {
        width: 100%;
        height: 375px;
        margin-bottom: 17px;
      }
      &-btn {
        width: 550px;
        height: 150px;
      }
    }
    &-group {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 132px 0 36px;
      &-list {
        width: 100%;
      }
      &-btn {
        width: 550px;
        height: 150px;
        margin-top: 50px;
      }
    }
    &-million {
      &-content {
        position: absolute;
        top: 376px;
        left: 46px;
        color: #502326;
        font-size: 26px;
        line-height: 45px;
      }
      .page-reading-day-card-btn {
        position: absolute;
        top: 858px;
        left: 125px;
        background: linear-gradient(0deg, #ff4C29 0%, #ff8E57 100%);
        box-shadow: 4px 7px 25px 0 rgba(230, 125, 22, 0.55), 1px 3px 4px 0 rgba(255, 237, 116, 0.45) inset, 0 -4px 10px 0 rgba(246, 95, 89, 0.55) inset;
      }
    }
    &-audio {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 136px 0 58px;
      &-list {
        width: 100%;
      }
      .page-reading-day-card-btn {
        background: linear-gradient(0deg, #ef9a21 0%, #ffc241 100%);
        box-shadow: 4px 7px 25px 0 rgba(230, 125, 22, 0.45), 1px 3px 4px 0 rgba(255, 237, 116, 0.45) inset, 0 -4px 10px 0 rgba(246, 95, 89, 0.55) inset;
        margin-top: 64px;
      }
    }
    &-project {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 155px 0 68px;
      &-list {
        width: 100%;
      }
      &-more {
        height: 58px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 22px;
        color: #5581f5;
        font-size: 38px;
        font-weight: @font-weight-bold;
        background: #ffeba7;
        margin-top: 42px;
      }
      .page-reading-day-card-btn {
        background: linear-gradient(0deg, #ef9a21 0%, #ffc241 100%);
        box-shadow: 4px 7px 25px 0 rgba(230, 125, 22, 0.45), 1px 3px 4px 0 rgba(255, 237, 116, 0.45) inset, 0 -4px 10px 0 rgba(246, 95, 89, 0.55) inset;
        margin-top: 53px;
      }
    }
    &-public-welfare {
      position: relative;
      width: 100%;
      height: 970px;
      margin-bottom: 160px;
      background: url('~@/pages/2021/ReadingDay/assets/img/public_welfare.png');
      background-size: 100%;
      .page-reading-day-card-btn {
        position: absolute;
        top: 782px;
        left: 125px;
        background: linear-gradient(92deg, #eb4c3c 0%, #ea6d60 100%);
        box-shadow: 4px 7px 25px 0 rgba(234, 109, 96, 0.45), 1px 3px 4px 0 rgba(255, 237, 116, 0.45) inset, 0 -4px 10px 0 rgba(246, 95, 89, 0.55) inset;
      }
    }
    &-card-btn {
      width: 500px;
      height: 100px;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: @color-white;
      font-size: 34px;
      font-weight: @font-weight-bold;
    }
    &-rule {
      padding: 60px 37px 30px;
      &-item {
        box-sizing: border-box;
        padding: 30px;
        color: @color-text-light;
        font-size: 26px;
        line-height: 45px;
        border-bottom: 1px solid #e5e5e5;
        &:last-child {
          border-bottom: 0;
        }
        span {
          display: inline-block;
          width: 32px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          border-radius: 50%;
          background: #ffd44c;
        }
      }
    }
  }
</style>
